import React, { } from 'react';
import { createBrowserRouter, Outlet } from "react-router-dom";

import LoginPage from "./pages/auth/features/LoginPage";
import ForgotPasswordPage from './pages/auth/features/ForgotPasswordPage';
import AccountVerificationPage from './pages/auth/features/AccountVerificationPage';
import ResetPasswordPage from './pages/auth/features/ResetPasswordPage';

import Admin from "./pages/admin/Admin";
import AdminProtected from "./pages/admin/AdminProtected";
import AuthProtected from "./pages/auth/AuthProtected";
import Dashboard from "./pages/admin/features/dashboard/Dashboard";
import DeviceListPage from "./pages/admin/features/devices/DeviceListPage";
import ScannerListPage from "./pages/admin/features/scanners/ScannerListPage";
import SchoolsListPage from "./pages/admin/features/schools/schools-list/SchoolListPage";
import NotFoundPage from "./pages/admin/NotFoundPage";
import SettlementAccountListPage from "./pages/admin/features/settlement-accounts/settlement-account-list/SettlementAccountListPage";
import SettlementAccountDetailsPage from "./pages/admin/features/settlement-accounts/settlement-account-details/SettlementAccountDetailsPage";
import UserPermissionsListPage from "./pages/admin/features/users/user-permissions/UserPermissionsListPage";
import UserRolesListPage from "./pages/admin/features/users/user-roles/UserRolesListPage";
import UserAccountListPage from "./pages/admin/features/users/user-accounts/UserAccountListPage";
import AppRatingsListPage from "./pages/admin/features/app-ratings/AppRatingsListPage";
import AppNotificationListPage from "./pages/admin/features/app-notifications/AppNotificationListPage";
import AppFeedListPage from "./pages/admin/features/app-feeds/feed-list/AppFeedListPage";
import CreateFeedPage from "./pages/admin/features/app-feeds/create-feed/CreateFeedPage";
import ManageSchoolPage from "./pages/admin/features/schools/manage-school/ManageSchoolPage";
import SchoolDetailsPage from './pages/admin/features/schools/manage-school/features/profile/pages/school-details/SchoolDetailsPage';
import SchoolConfigurationsPage from './pages/admin/features/schools/manage-school/features/profile/pages/school-configurations/SchoolConfigurationsPage';
import SchoolCampusListPage from './pages/admin/features/schools/manage-school/features/profile/pages/school-campuses/SchoolCampusListPage';
import SchoolAdminAccountsListPage from './pages/admin/features/schools/manage-school/features/profile/pages/admin-accounts/SchoolAdminAccountsListPage';
import SchoolManagementGeneralPage from './pages/admin/features/schools/manage-school/features/management/pages/general/SchoolManagementGeneralPage';
import SchoolServiceProviderListPage from './pages/admin/features/schools/manage-school/features/canteen/pages/service-providers/SchoolServiceProviderListPage';
import AppConfigurationsPage from './pages/admin/features/app-configurations/AppConfigurationsPage';
import SchoolCanteenCSPManagersListPage from './pages/admin/features/schools/manage-school/features/canteen/pages/csp-managers/SchoolCanteenCSPManagersListPage';
import SchoolPaymentConfigurationsPage from './pages/admin/features/schools/manage-school/features/payments/pages/configurations/SchoolPaymentConfigurationsPage';
import StudentListPage from './pages/admin/features/students/student-list/StudentListPage';
import ManageStudentPage from './pages/admin/features/students/manage-student/ManageStudentPage';
import StudentDetailsPage from './pages/admin/features/students/manage-student/features/profile/student-details/StudentDetailsPage';
import StudentParentsListPage from './pages/admin/features/students/manage-student/features/profile/parents/StudentParentsListPage';
import StudentDelegatesListPage from './pages/admin/features/students/manage-student/features/profile/delegates/StudentDelegatesListPage';
import StudentPaymentPage from './pages/admin/features/students/manage-student/features/payments/StudentPaymentPage';
import StudentInvoiceListPage from './pages/admin/features/students/manage-student/features/payments/pages/invoices/StudentInvoiceListPage';
import StudentTransactionListPage from './pages/admin/features/students/manage-student/features/payments/pages/transactions/StudentTransactionListPage';
import StudentPaymentDetailsPage from './pages/admin/features/students/manage-student/features/payments/pages/payment-details/StudentPaymentDetailsPage';
import SchoolModulesListPage from './pages/admin/features/schools/manage-school/features/profile/pages/modules/SchoolModulesListPage';
import StudentActivitiesPage from './pages/admin/features/students/manage-student/features/profile/activities/StudentActivitiesPage';
import CreateInvoicePage from './pages/admin/features/payments/invoices/create-invoice/CreateInvoicePage';
import ThirdPartyListPage from './pages/admin/features/payments/third-parties/third-party-list/ThirdPartyListPage';
import ThirdPartyDetailsPage from './pages/admin/features/payments/third-parties/third-party-details/ThirdPartyDetailsPage';
import ThirdPartyForm from './pages/admin/features/payments/third-parties/third-party-form/ThirdPartyForm';
import SchoolClassroomList from './pages/admin/features/schools/manage-school/features/profile/pages/classrooms/SchoolClassroomList';
import SchoolProfilePage from './pages/admin/features/schools/manage-school/features/profile/SchoolProfilePage';
import SchoolCanteenPage from './pages/admin/features/schools/manage-school/features/canteen/SchoolCanteenPage';
import SchoolPaymentPage from './pages/admin/features/schools/manage-school/features/payments/SchoolPaymentPage';
import SchoolManagementPage from './pages/admin/features/schools/manage-school/features/management/SchoolManagementPage';
import BulkSmsDetailsPage from './pages/admin/features/schools/manage-school/features/management/pages/bulk-sms/BulkSmsDetailsPage';
import ModuleListPage from './pages/admin/features/payments/subscriptions/modules/modules-list/ModuleListPage';
import CreateModulePage from './pages/admin/features/payments/subscriptions/modules/create-module/CreateModulePage';

import CreateSubscriptionPlanPage from './pages/admin/features/payments/subscriptions/plans/create-subscription-plan/CreateSubscriptionPlanPage';
import ManageModulePage from './pages/admin/features/payments/subscriptions/modules/manage-module/ManageModulePage';
import SchoolProcessorsSettingsListPage from './pages/admin/features/schools/manage-school/features/payments/pages/processors/SchoolProcessorsSettingsListPage';
import PlanListPage from './pages/admin/features/subscriptions/plans/PlanListPage';
import PlanDetailsPage from './pages/admin/features/subscriptions/plans/PlanDetailsPage';
import AppCategoryListPage from './pages/admin/features/apps/categories/AppCategoryListPage';
import AppProvidersListPage from './pages/admin/features/apps/providers/AppProvidersListPage';


const router = createBrowserRouter([
    {
        path: "/login",
        element:
            <AuthProtected>
                <LoginPage />
            </AuthProtected>,
    },
    {
        path: "/forgot-password",
        element:
            <AuthProtected>
                <ForgotPasswordPage />
            </AuthProtected>,
    },
    {
        path: "/verify-account",
        element:
            <AuthProtected>
                <AccountVerificationPage />
            </AuthProtected>,
    },
    {
        path: "/reset-password",
        element:
            <AuthProtected>
                <ResetPasswordPage />
            </AuthProtected>,
    },
    /* {
        path: "*",
        element:
            <AdminProtected>
                <Admin />
            </AdminProtected>,
    }, */
    {
        path: "/",
        element:
            <AdminProtected>
                <Admin />
            </AdminProtected>,
        children: [
            {
                path: "/",
                element: <Dashboard />,
            },
            {
                path: "/schools",
                element: <SchoolsListPage />,
            },
            {
                path: "/schools/:schoolId",
                element: <ManageSchoolPage />,
                children: [
                    {
                        path: "",
                        element: <SchoolProfilePage />,
                        children: [
                            {
                                path: "",
                                element: <SchoolDetailsPage />,
                            },
                            {
                                path: "configurations",
                                element: <SchoolConfigurationsPage />,
                            },
                            {
                                path: "campuses",
                                element: <SchoolCampusListPage />,
                            },
                            {
                                path: "classrooms",
                                element: <SchoolClassroomList />,
                            },
                            {
                                path: "admin-accounts",
                                element: <SchoolAdminAccountsListPage />,
                            },
                            {
                                path: "modules",
                                element: <SchoolModulesListPage />,
                            },
                        ]
                    },
                    {
                        path: "canteen",
                        element: <SchoolCanteenPage />,
                        children: [
                            /* {
                     path: "canteen",
                     element: <SchoolCanteenGeneralPage />,
                 }, */
                            {
                                path: "",
                                element: <SchoolServiceProviderListPage />,
                            },
                            {
                                path: "csp-managers",
                                element: <SchoolCanteenCSPManagersListPage />,
                            },
                        ]
                    },
                    {
                        path: "payments",
                        element: <SchoolPaymentPage />,
                        children: [
                            {
                                path: "",
                                element: <SchoolPaymentConfigurationsPage />,
                            },
                            {
                                path: "processors",
                                element: <SchoolProcessorsSettingsListPage />,
                            },
                        ]
                    },
                    {
                        path: "manage",
                        element: <SchoolManagementPage />,
                        children: [
                            {
                                path: "",
                                element: <SchoolManagementGeneralPage />,
                            },
                            {
                                path: "bulk-sms",
                                element: <BulkSmsDetailsPage />,
                            },
                        ]
                    },
                    {
                        path: "*",
                        element: <NotFoundPage pageTitle='Manage School' />,
                    },
                ]
            },
            {
                path: "/students",
                element: <StudentListPage />,
            },
            {
                path: "/students/:schoolId/:studentId",
                element: <ManageStudentPage />,
                children: [
                    // profile
                    {
                        path: "",
                        element: <StudentDetailsPage />,
                    },
                    {
                        path: "parents",
                        element: <StudentParentsListPage />,
                    },
                    {
                        path: "pickup-persons",
                        element: <StudentDelegatesListPage />,
                    },
                    {
                        path: "activities",
                        element: <StudentActivitiesPage />,
                    },
                    {
                        path: "payments",
                        element: <StudentPaymentPage />,
                        children: [
                            {
                                path: "",
                                element: <StudentPaymentDetailsPage />,
                            },
                            {
                                path: "invoices",
                                element: <StudentInvoiceListPage />,
                            },
                            {
                                path: "transactions",
                                element: <StudentTransactionListPage />,
                            }
                        ],
                    },
                ]
            },
            {
                path: "/scanners",
                element: <ScannerListPage />,
            },
            {
                path: "/devices",
                element: <DeviceListPage />,
            },
            {
                path: "/settlement-accounts",
                element: <SettlementAccountListPage />,
            },
            {
                path: "/settlement-accounts/:accountId",
                element: <SettlementAccountDetailsPage />,
            },
            {
                path: "/users/accounts",
                element: <UserAccountListPage />,
            },
            {
                path: "/users/permissions",
                element: <UserPermissionsListPage />,
            },
            {
                path: "/users/roles",
                element: <UserRolesListPage />,
            },
            {
                path: "/payments",
                element: <Outlet />,
                children: [
                    {
                        path: "subscriptions",
                        element: <Outlet />,
                        children: [
                            {
                                path: "plans",
                                element: <Outlet />,
                                children: [
                                    {
                                        path: "",
                                        element: <PlanListPage />,
                                    },
                                    {
                                        path: "create",
                                        element: <CreateSubscriptionPlanPage />,
                                    },
                                    {
                                        path: ":planId",
                                        element: <PlanDetailsPage />,
                                    },
                                ]
                            },
                            {
                                path: "modules",
                                element: <Outlet />,
                                children: [
                                    {
                                        path: "",
                                        element: <ModuleListPage />,
                                    },
                                    {
                                        path: "create",
                                        element: <CreateModulePage />,
                                    },
                                    {
                                        path: ":moduleId",
                                        element: <ManageModulePage />,
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        path: "invoices",
                        element: <Outlet />,
                        children: [
                            {
                                path: "create",
                                element: <CreateInvoicePage />,
                            },
                            {
                                path: ":invoiceId",
                                element: <CreateInvoicePage />,
                            },
                        ]
                    },
                    {
                        path: "third-parties",
                        element: <Outlet />,
                        children: [
                            {
                                path: "",
                                element: <ThirdPartyListPage />,

                            },
                            {
                                path: "new",
                                element: <ThirdPartyForm />,
                            },
                            {
                                path: ":thirdPartyId",
                                element: <ThirdPartyDetailsPage />,
                            },
                        ]
                    },
                ],
            },
            {
                path: 'apps',
                element: <Outlet />,
                children: [
                    {
                        path: 'providers',
                        element: <AppProvidersListPage />
                    },
                    {
                        path: 'categories',
                        element: <AppCategoryListPage />
                    }
                ]
            },
            {
                path: "/app-ratings",
                element: <AppRatingsListPage />,
            },
            {
                path: "/app-notifications",
                element: <AppNotificationListPage />,
            },
            {
                path: "/feeds",
                element: <AppFeedListPage />,
            },
            {
                path: "/feeds/create",
                element: <CreateFeedPage />,
            },
            {
                path: "/feeds/:feedId",
                element: <CreateFeedPage />,
            },

            {
                path: "/app-configurations",
                element: <AppConfigurationsPage />,
            },

            {
                path: "*",
                element: <NotFoundPage />,
            },
        ]
    },
]);


export default router;